import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'integrationDescription',
  standalone: false,
})
export class IntegrationDescriptionPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const trimmed = value?.trim();
    return trimmed ? trimmed : '—';
  }
}
